import React from "react"
import styled, { css } from "styled-components"

import { useStore } from '../../zustandStore'
 
const ObsStateDisplay = () => {
  const {
    event,
    obsState
  } = useStore(
    state => ({
      event:    state.event,
      obsState: state.obsState,
    })
  )

  return (
    <FakeTerminalPreElement>
      {JSON.stringify(obsState, null, 2)}
    </FakeTerminalPreElement>
  )
}

export default ObsStateDisplay

const FakeTerminalPreElement = styled.pre`
  font-family: 'Courier New', Courier, monospace;
  color: #c3ffc6;
  font-size: 0.95em;
  border: 2px solid #aaaaaa;
  background-color: #282828;
  border-radius: 0.2em;
  padding: 0.3em;
`